module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.href) ? _c('a', {
    staticClass: "ed-btn-rectangle",
    attrs: {
      "href": _vm.href,
      "disabled": _vm.disabled,
      "target": _vm.target,
      "rel": _vm.newRel
    }
  }, [_vm._t("default")], 2) : _c('button', {
    staticClass: "ed-btn-rectangle",
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2371e6fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/edoc-library/src/components/rectangleButton/rectangleButton.vue
// module id = 696
// module chunks = 42